module.exports = __webpack_public_path__ + "img/wx-upload-phone.png";